
import { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";

 function HeaderNoMenu() {
     const [responsiveMenu, setResponsiveMenu] = useState(false);
     const onClickHandler = (e)=>{
        setResponsiveMenu(!responsiveMenu);
     };
     return (
         <>
         <header>
        <div className="container">
            <div className="header-content">
                <div className="row">
                    <div className="col-lg-2 col-md-6 col-sm-6 col-10">
                        <div className="logo">
                            <div className="sec-title">
                             
                                <img src="../../images/bb.png"  onError={(e) => {
    e.currentTarget.onerror = null; // prevent infinite loop
    e.currentTarget.src = "../../../../images/bb.png";
  }}  />
                            </div>
                             {/*   <!--sec-title end-->  */}
                        </div> {/*  <!--logo end-->  */}
                    </div>
                    <div className="col-lg-10 col-md-6 col-sm-6 col-2">
                    </div>
                </div>
            </div> {/* <!--header-content end--> */}
        </div>
    </header> {/* <!--header end--> */}



         </>
     );
 }

 export {HeaderNoMenu}